var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.18 14.988C29.18 25.8676 15.09 35.1929 15.09 35.1929C15.09 35.1929 1 25.8676 1 14.988C1 11.2782 2.48448 7.72025 5.12686 5.09699C7.76925 2.47373 11.3531 1 15.09 1C18.8269 1 22.4107 2.47373 25.0531 5.09699C27.6955 7.72025 29.18 11.2782 29.18 14.988Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.089 19.6432C17.6829 19.6432 19.7857 17.5557 19.7857 14.9805C19.7857 12.4054 17.6829 10.3179 15.089 10.3179C12.4951 10.3179 10.3924 12.4054 10.3924 14.9805C10.3924 17.5557 12.4951 19.6432 15.089 19.6432Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaction);
export default __webpack_public_path__ + "static/media/loaction.15b0868eb5215f7c6ee3ee2164005c3d.svg";
export { ForwardRef as ReactComponent };